
export const TEST_CLICK = 'TEST_CLICK'

export function testClick(par) {
    return (dispatch, getState) => {
        dispatch({type: TEST_CLICK, par})
    }
}


// WEBPACK FOOTER //
// ./src/test/actions.js